/* eslint-disable no-unused-vars */
import React from "react";
import { sortObjectsByAlphabet } from "../utils";
import Select from "react-select";


function ChooseDeviceField({ devices = [], value, onChange }) {

    const handleChange = (selectedOption) => {
        let selectDevice = null;
        // let sshAlgorithm ='';
        if (selectedOption && selectedOption.value > 0) {
            selectDevice = devices.find(device => device.id === Number(selectedOption.value));
            // const sshAlgorithmText = await additionalAlgorithmService.getDeviceSSHAlgorithm(id);
            // if (selectDevice.sshAlgorithm) {
            //     sshAlgorithm=selectDevice.sshAlgorithm;
            // }else {
            //     sshAlgorithm='';
            // }
        }

        // let disabledButton = true;
        // if (!selectDevice) {
        //     disabledButton = true;
        // } else {
        //     disabledButton = false;
        // }

        onChange(selectDevice);
    }

    const devicesCopy = sortObjectsByAlphabet(devices, 'hostName');

    const options = [
        { value: 0, label: 'Choose Device' },
        ...(devicesCopy || []).map(device => ({ value: device.id, label: device.hostName }))
    ];

    const selectedOption = value ? options.find(opt => opt.value === value.id) : options[0];

    return (
        <Select
            className="oct_selectsearch-v2"
            classNamePrefix="oct-selectsearchsub-v2"
            value={selectedOption}
            onChange={handleChange}
            options={options}
            isSearchable={true}
            placeholder="Choose Device"
            noOptionsMessage={() => "No devices available"}
        />
    );
}

export default ChooseDeviceField;
